import { QueryClient } from "@tanstack/react-query";
import { redirect } from "react-router-dom";
import { getCabinetQueryOptions } from "@/entities/cabinet/api/getCabinetQueryOptions";

export const refinanceLoader = (queryClient: QueryClient) => async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    return redirect("/auth", { status: 301 });
  }

  const cabinetResponse = await queryClient.fetchQuery(
    getCabinetQueryOptions(token),
  );

  const agreementData = cabinetResponse.data?.agreement;
  const hasRefinance = !!agreementData?.prolongation_available;
  const refinanceAmount =
    typeof agreementData?.calculation?.prolongation === "number";

  if (!hasRefinance || !refinanceAmount) {
    return redirect("/cabinet", { status: 301 });
  }

  return cabinetResponse;
};
